import axios from 'axios'
import TokenService  from './storage.service'
import router from "../router";

const ApiService = {

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
        axios.interceptors.response.use((response) => {
            return response
        }, function (error) {

            if (error.response.status === 401) {
                router.push('/');
                return Promise.reject(error);
            }
        })
    },

    setHeader() {
        axios.defaults.headers.common["Authorization"] = `Bearer ${TokenService.getToken()}`
    },

    removeHeader() {
        axios.defaults.headers.common = {}
    },

    get(resource) {
        return axios.get(resource)
    },

    post(resource, data) {
        return axios.post(resource, data)
    },

    put(resource, data) {
        return axios.put(resource, data)
    },

    delete(resource) {
        return axios.delete(resource)
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
     **/
    customRequest(data) {
        return axios(data)
    }
}

export default ApiService
